import { render, staticRenderFns } from "./OrdersFBMTableUserTableMobile.vue?vue&type=template&id=450e5b2a&scoped=true"
import script from "./OrdersFBMTableUserTableMobile.vue?vue&type=script&lang=js"
export * from "./OrdersFBMTableUserTableMobile.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBMTableUserTableMobile.vue?vue&type=style&index=0&id=450e5b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450e5b2a",
  null
  
)

export default component.exports